import { NamespaceConsumer } from '@ux/namespace-component';
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Create a header which can highlight a set of DropdownItems.
 *
 * @class DropdownHeader
 * @displayName DropdownHeader (Web)
 * @public
 */
export default class DropdownHeader extends NamespaceConsumer {
  render() {
    return (
      <div role='sectionhead' className={ this.namespace('dropdown-header', 'title', 'small') }>
        { this.props.children }
      </div>
    );
  }
}

/**
 * Children should be provided.
 *
 * @enum {Object} propTypes
 * @public
 */
DropdownHeader.propTypes = {
  /** Contents of a dropdown header */
  children: PropTypes.node.isRequired
};
